var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rlc__icon-c"},[(_vm.icon === 'check')?_c('CheckIcon',{staticClass:"rlc__check-icon"}):_vm._e(),(_vm.icon === 'alert')?_c('AlertIcon',{staticClass:"rlc__alert-icon"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }